import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetStartkitVouchersParams, GetStartkitVouchersResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getStartkitVouchers = createAsyncThunk<
  GetStartkitVouchersResponse,
  GetStartkitVouchersParams
>(
  'vouchers/getStartkitVouchers',
  async ({ marathonId, searchTerm }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getStartkitVouchers({ marathonId, searchTerm });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting startkit vouchers", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting startkit vouchers", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);